import { Options } from 'vue-class-component';
import DeviceSettingsComponent from '../DeviceSettingsComponent';
import {
  CommandDirection,
  ShutterMode,
} from '@/../client-generator/generated-clients/device-settings';

@Options({
  name: 'ShutterCommandSettings',
})
export default class ShutterCommandSettings extends DeviceSettingsComponent {
  ShutterMode = ShutterMode;
  CommandDirection = CommandDirection;

  get settings() {
    return this.defaultSettings.shuttersCommandSettings;
  }
}
